import type { WeChatProfitSharingQueryAmountActionConfig } from '@lighthouse/shared'
import { useAtomData } from '@lighthouse/shared'
import { wechatMerchantCardLabel } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { otherPlatformListAtom } from '@/atoms/application/state'

import * as CM from '../styles'
import * as SC from './styles'

type WeChatProfitSharingQueryAmountCardProps = {
    config: WeChatProfitSharingQueryAmountActionConfig
}

const WeChatProfitSharingQueryAmountCard: React.FC<WeChatProfitSharingQueryAmountCardProps> = ({ config }) => {
    const otherPlatformList = useAtomData(otherPlatformListAtom)

    const merchantLabel = useMemo(
        () => wechatMerchantCardLabel(otherPlatformList, config?.paymentAccountId),
        [otherPlatformList, config?.paymentAccountId]
    )

    if (!merchantLabel) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>{merchantLabel}</SC.TypeName>
            <SC.TypeName>查询剩余待分金额</SC.TypeName>
        </CM.CardItemContainer>
    )
}

export default WeChatProfitSharingQueryAmountCard
